import React from 'react';
import { Box, MediaQuery } from '@mantine/core';
import "./background.css"; // Import the CSS file

function InlineBackground() {

  return (
    <MediaQuery largerThan='md' styles={{ display: 'none' }}>
      <Box pos='relative' w='100%' h={{ base: 120, md: 180 }} className='inline'>
        <Box className='stretch'>
          <Box className='fade'>
            <Box bg='gray.2' className='pattern' />
          </Box>
        </Box>
      </Box>
    </MediaQuery>
  );
}

export default InlineBackground;